import axios from 'axios';
import { SessionExpiredError } from './SessionExpiredError';

/**
 * Restaura un archivo marcado como deleted
 * @param {string} sessionToken - Token de sesión
 * @param {string} fileId - ID del archivo a restaurar
 * @returns {Promise<Object>} Respuesta del servidor
 */
export const restoreFile = async (sessionToken, fileId) => {
  try {
    const response = await axios.patch(
      `/v1/sat/tramites/files/${fileId}/restore`,
      {},
      {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
      },
    );

    if (!response.data) {
      throw new Error(response.data.error?.message || 'Error al restaurar archivo');
    }

    return response.data;
  } catch (error) {
    console.error('Error en restoreFile:', error);

    const statusCode = error.response?.status;
    const message = error.response?.data?.error;
    const isTokenInvalidOrExpired =
      message?.toLowerCase().includes('token') &&
      (message?.toLowerCase().includes('inválido') || message?.toLowerCase().includes('expirado'));

    if (statusCode === 422 && isTokenInvalidOrExpired) {
      throw new SessionExpiredError(statusCode, message);
    }

    throw new Error(message || error.message || 'No se pudo restaurar el archivo');
  }
};
